import{cubicBezier as o}from"./cubic-bezier.mjs.js";const r=o(.42,0,1,1),c=o(0,0,.58,1),e=o(.42,0,.58,1);export{r as easeIn,e as easeInOut,c as easeOut};
